<template>
    <div class="flex col scanning_box">    
        <!-- <div class="unit_haeder">中国消费扶贫生活馆</div> -->
        <div class="unit_boxs">
            <div class="unit_boxs_list">
                <span class="unit_boxs_list_text">参与帮扶单位数</span>
                <span class="unit_boxs_list_num">{{count}}</span>
            </div>
            <div class="unit_boxs_list">
                <span class="unit_boxs_list_text">帮扶消费销售额(元)</span>
                <span class="unit_boxs_list_num">{{orderTamt?numFilter(orderTamt):'0'}}</span>
            </div>
        </div>
        <div class="unit_name flex flex-center">区县排名榜</div>
        
        <div class="unit_schedule">
            <div class="unit_schedule_list" v-for="item in scheduleList" :key="item.id">
                <div class="unit_schedule_text">
                    <span>{{item.city+item.county}}</span>
                    <span>{{item.orderTamt}}元</span>
                </div>
                <div class="unit_schedule_totel" :style="{'width':(Number(item.orderTamt)/Number(scheduleTotel))*100+'%'}"></div>
            </div>
        </div>
        <div class="unit_name flex flex-center">实时播报</div>
        <div class="unit_center">
            <div class="unit_center_footer">
                <div class=" flex footer_boxs">
                    <div class="footer_text" style="flex:1.2">购买主体</div>
                    <div class="footer_text" style="flex:1.5">商品</div>
                    <div class="footer_text" style="flex:0.8">数量</div>
                    <div class="footer_text" style="flex:1">金额(元)</div>
                    <!-- <div class="footer_text" style="flex:1.5">上报时间</div> -->
                </div>
                <!-- <van-list
                    v-model="loading"
                    :finished="finished"
                    :finished-text="finishedText"
                    @load="onLoad"
                > -->
                <div class="unit_center_list_box">
                    <div class="flex col unit_center_list">
                        <div class="flex row footer_list" v-for="(item,index) in orderList" :key="index">
                            <div class="footer_nums flex flex-center" style="flex:1.2">{{item.cusName}}</div>
                            <div class="flex flex-center footer_nums" style="flex:1.5;text-align: left;">{{item.goName}}</div>
                            <div class="flex flex-center footer_nums" style="flex:0.8">{{item.amount}}</div>
                            <div class="flex flex-center footer_nums" style="flex:1">{{numFilter(item.pyAmt)}}</div>
                            <!-- <div class="flex flex-center footer_nums" style="flex:1.5">{{item.date}}</div> -->
                            
                        </div>
                    </div>
                </div>
                    
                <!-- </van-list> -->
                
            </div>
        </div>
        <div class="pofig flex row">
            
            <div class="flex-item pofig_item flex row flex-center">
                <img src="../assets/images/statistics.png" class="pofig_item_imgs" alt="" srcset="">
                数据统计
            </div>
            <div class="flex-item pofig_item flex row flex-center" @click="order">
                <img src="../assets/images/Inquire.png" class="pofig_item_imgs" alt="" srcset="">
                单位查询
            </div>
        </div>
    </div>
</template>
<script>
import {totalByCust,queryPageByRegion,queryRealOrderInfo} from '../api/directreport'
export default {
    name: "login",
    data(){
        return{
            list:[
                {id:1,name:'参与帮扶单位数',num:'31'},
                {id:2,name:'参与帮扶个人数',num:'842'},
                {id:3,name:'帮扶次数',num:'8431'},
                {id:4,name:'帮扶消费销售额(万元)',num:'842.21'},
            ],
            scheduleList:[
                // {id:1,name:'南昌市青山湖区',num:'4112.20',totel:60},
                // {id:2,name:'南昌市青山湖区',num:'4112.20',totel:70},
                // {id:3,name:'南昌市青山湖区',num:'4112.20',totel:50},
                // {id:4,name:'南昌市青山湖区',num:'4112.20',totel:80},
            ],
            count:0,
            orderTamt:0,
            scheduleTotel:0,
            loading: true, //上拉加载中
            finished: false, //上拉加载结束
            finishedText:'',
            orderInfo:{
                pageNumber:1,
                pageSize:30
            },
            orderList:[],
            numFilter(value) {
                const realVal = parseFloat(value).toFixed(2);
                return realVal;
            }

        }
    },
    components: {
    },
    mounted(){
        totalByCust({reportTp:'cust'}).then(res=>{
            if(res.data.status=='000000'){
                console.log(res.data.data,'data')
                let obj = res.data.data
                this.count = obj.count
                this.orderTamt = obj.orderTamt

            }

        })
        queryPageByRegion({reportTp:'region',"pageNo": 1,
    "pageSize": 10}).then(res=>{
            if(res.data.status=='000000'){
                this.scheduleList = res.data.data.data||[]
                this.scheduleTotel = res.data.data.data[0].orderTamt
                console.log(this.scheduleTotel)
            }
        })
        this.queryRealOrderInfo()
        // queryRealOrderInfo({}).then(res=>{

        // })
    },
    methods:{
       order(){
           this.$router.push('/login')
       },
       // 单位查询加载
        onLoad(){
            this.queryRealOrderInfo()
        },
       queryRealOrderInfo(){
           queryRealOrderInfo(this.orderInfo).then(res=>{
               if(res.data.code=='000000'){
                   this.orderList =res.data.data.list
                   this.orderList.push(res.data.data.list[0])
                    // this.orderInfo.pageNumber++
                    // if (this.orderList.length < 1) {
                    //     this.finishedText = "暂无数据";
                    //     this.finished = true; //上拉结束
                    // } else if (res.data.data.list.length < 10) {
                    //     this.finishedText = "没有更多了";
                    //     this.finished = true; //上拉结束
                    // } else {
                    //     this.finished = false;
                    //     this.loading = false;
                    // }
               }
           })
       }
    }
}
</script>
<style scoped>
    body{
        background: #999999;
    }
    .scanning_box{
        padding: 0.2rem;
        box-sizing: border-box;
    }
    .unit_schedule{
        padding: 0.38rem 0.25rem 0 0.25rem;
        box-sizing: border-box;
        background: #fff;
        margin-bottom: 0.25rem;
    }
    .unit_name{
        height: 0.6rem;
        background: #FF6C6D;
        font-size: 00.24rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
    }
    .unit_schedule_list{
        width: 100%;
        padding-bottom: 0.38rem;
        box-sizing: border-box;
    }
    .unit_schedule_text{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0.3rem;
        font-size: 0.24rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #282828;
    }
    .unit_schedule_totel{
        width:0%;
        height: 0.2rem;
        background: #40F0C9;
        border-radius: 0.1rem;
    }
     .unit_haeder{
        height: 1.28rem;
        background: #B22627;
        padding-bottom: 0.2rem;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
     }
     .unit_boxs{
         /* padding: 0.2rem; */
         padding-bottom: 0.2rem;
         box-sizing: border-box;
         display: flex;
         justify-content: space-between;
         align-items: center;
     }
     .unit_boxs_list{
         width: 3.4rem;
         height: 1.7rem;
         background: #fff;
         display: flex;
         justify-content: center;
         flex-direction: column;
         padding-left: 0.3rem;
         box-sizing: border-box;

     }
     .unit_boxs_list_text{
        font-size: 0.24rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #282828;
     }
     .unit_boxs_list_num{
        font-size: 0.48rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #B22627;
     }

     .unit_center{
         /* padding: 0.14rem 0.18rem 1.38rem 0.18rem; */
         box-sizing: border-box;
         margin-bottom: 1.2rem;
     }
     .unit_center_search{
        height: 0.8rem;
        background: #FFFFFF;
        border-radius: 0.05rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 0.18rem;
        box-sizing: border-box;
        margin-bottom: 0.2rem;
     }
     .search_img{
        height: 0.28rem;
        width: 0.28rem;
     }
     .search_text{
        flex: 1;
        height: 0.6rem;
        line-height: 0.6rem;
        font-size: 0.3rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666;
        padding-left: 0.2rem;
        box-sizing: border-box;
     }
     .search_cancel{
        font-size: 0.26rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
     }
     .unit_center_select{
         display: flex;
         flex-direction: row;
         height: 0.8rem;
         margin-bottom: 0.29rem;
     }
     .select_btns{
        width: 1.54rem;
        height: 0.8rem;
        background: #FFFFFF;
        border-radius: 0.05rem;
        text-align: center;
     }
     .unit_center_footer{
         background: #fff;
     }
     .unit_bjs{
        background: #FFFFFF;
        padding: 0 0.12rem;
        box-sizing: border-box;
        border-radius: 0.06rem;
        margin-bottom: 0.15rem;
     }
     .footer_boxs{
         padding:0 0.2rem;
         padding-top: 0.27rem;
         padding-bottom: 0.34rem;
         box-sizing: border-box;
         align-items: center;
     }
     .footer_name{
        height: 0.6rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: center;
        line-height: 0.6rem;
        font-size: 0.24rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
     }
     .unit_bjs_fot{
         padding-top: 0.5rem;
         padding-bottom: 0.3rem;
         box-sizing: border-box;

     }
     .footer_text{
        font-size: 0.24rem;
        text-align: center;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #282828; 
        
     }
     .unit_center_list_box{
        height: 1.5rem;
        width: 100%;
        overflow: hidden;
     }
     .unit_center_list{
         padding: 0 0.2rem;
         box-sizing: border-box;
         animation: myMove 40s linear infinite;
        animation-fill-mode: forwards;
         /* margin-bottom: 1.2rem; */
     }
     @keyframes myMove {
        0% {
            transform: translateY(0);
        }
        10% {
            transform: translateY(-2rem);
        }
        20% {
            transform: translateY(-4rem);
        }
        30% {
            transform: translateY(-6rem);
        }
        40% {
            transform: translateY(-8rem);
        }
        50% {
            transform: translateY(-10rem);
        }
        60% {
            transform: translateY(-12rem);
        }
        70% {
            transform: translateY(-14rem);
        }
        80% {
            transform: translateY(-16rem);
        }
        90% {
            transform: translateY(-18rem);
        }
        97% {
            transform: translateY(-19rem);
        }
        100% {
            transform: translateY(-19.5rem);
        }
    }
     .footer_list{
         /* height: 0.5rem; */
         padding-bottom: 0.19rem;
         box-sizing: border-box;
         border-bottom: 0.01rem solid #DDDDDD;
         margin-bottom: 0.1rem;
     }
     .footer_nums{
        padding: 0 0.02rem;
        box-sizing: border-box;
        font-size: 0.24rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        text-align: center;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
     }
     .pofig{
         position: fixed;
         left: 0;
         bottom: 0;
         height: 0.98rem;
         width: 100%;
     }
     .pofig_item{
        background: #FFFFFF;
        box-shadow: 0px 1px 5px 0px rgba(69, 69, 69, 0.2);
        font-size: 0.28rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
     }
     .pofig_item_imgs{
         width: 0.24rem;
         height: 0.26rem;
         margin-right: 0.1rem;
     }
     .van-radio--horizontal{
         margin-right: 0.12rem;
         font-size: 0.24rem;
     }
</style>
   
    
